import { Component } from '@angular/core';
import { DialogService } from '@service/dialog.service';
import { MobileService } from '@service/mobile.service';
import { ScrollService } from '@service/scroll.service';
import { StateService } from '@service/state.service';
import { UserService } from '@service/user/user.service';

@Component({
  selector: 'newsfeed-bottom-banner',
  templateUrl: './newsfeed-bottom-banner.component.html',
  styleUrls: ['./newsfeed-bottom-banner.component.scss'],
  host: {
    '[class.is-logged-in]': 'userService.isLoggedIn',
  },
})
export class NewsfeedBottomBannerComponent {
  get firstRowHeadlineDesktop(): string {
    return this.userService.isLoggedIn ? 'Sei aktiv und sammle Woodcoins!' : 'Gemeinsam stark für den Holzbau!';
  }

  get firstRowHeadlineMobileAndTablet(): string {
    return this.userService.isLoggedIn
      ? 'Sei aktiv<br>und sammle<br>Woodcoins!'
      : '<br>Gemeinsam<br>stark für den<br>Holzbau!';
  }

  get secondRowParagraphFirstLine(): string {
    return this.userService.isLoggedIn ? '' : '';
  }

  get secondRowParagraphSecondLine(): string {
    return this.userService.isLoggedIn
      ? 'Poste Anzeigen in Marktplatz und Jobbörse oder stelle dich vor im Blog.'
      : 'Vom Azubi bis zum Meister. Wir sind eine Gemeinschaft mit 15.000 Mitgliedern.';
  }

  get secondRowParagraphThirdLine(): string {
    return this.userService.isLoggedIn ? '' : 'Online informieren, austauschen und mitmachen.';
  }

  get secondRowLastLine(): string {
    return this.userService.isLoggedIn ? 'Aktive Mitglieder gewinnen: Poste, kommentiere und sammle Woodcoins!' : '';
  }

  constructor(
    public userService: UserService,
    public dialogService: DialogService,
    public mobileService: MobileService,
    public stateService: StateService,
    public scrollService: ScrollService,
  ) {}

  public goto(state) {
    this.stateService.goto(state).then(() => {
      this.scrollService.scrollToTop();
    });
  }
}
